/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rails_PlatformsInputs */

const en_directory_rails_platforms = /** @type {(inputs: Directory_Rails_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms`)
};

const zh_directory_rails_platforms = /** @type {(inputs: Directory_Rails_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台`)
};

/**
* | output |
* | --- |
* | "Platforms" |
*
* @param {Directory_Rails_PlatformsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_platforms = /** @type {((inputs?: Directory_Rails_PlatformsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_PlatformsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_platforms(inputs)
	return zh_directory_rails_platforms(inputs)
});
export { directory_rails_platforms as "directory.rails.platforms" }